<!--
  Sin gastos no se pinta nada: el desglose de precio no debe ganar ruido cuando
  el servicio no tiene ninguno.
-->
<div *ngIf="expenses.length > 0" class="expense-summary-list">
  <app-expense-summary-card
    *ngFor="let expense of expenses; trackBy: trackById"
    [expense]="expense"
    [currencySymbol]="currencySymbol"
    (openDetail)="openDetail($event)"
  ></app-expense-summary-card>

  <!-- Sólo cuando hay más de una página: aquí lo normal son uno o dos gastos. -->
  <div *ngIf="pageCount > 1" class="expense-summary-list__pager">
    <span class="expense-summary-list__count">
      {{ resultsKey | translate : { count: totalCount } }}
    </span>

    <tui-pagination
      size="m"
      [index]="pageIndex"
      [length]="pageCount"
      (indexChange)="onPageIndexChange($event)"
    ></tui-pagination>
  </div>
</div>

<p *ngIf="isLoading" class="expense-summary-list__state">
  {{ 'Loading' | translate }}
</p>

<p
  *ngIf="hasError"
  class="expense-summary-list__state expense-summary-list__state--error"
>
  {{ 'expenses.summary_error' | translate }}
</p>
